var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography,
    breakpoints = _ref.breakpoints;
  return {
    itemAnalysisRowPadding: spacing.small,
    itemAnalysisRowMargin: spacing.small,
    headerTextColor: colors.contrasts.grey4570,
    headerTextFontSize: typography.fontSizeXSmall,
    metricNoteFontSize: typography.fontSizeMedium,
    metricNoteColor: colors.contrasts.grey4570,
    metricsRowLowerPadding: spacing.large,
    stemFontSize: typography.fontSizeXSmall,
    stemLineHeight: typography.lineHeight,
    stemMargin: spacing.small,
    emptyTextPadding: spacing.small,
    emptyTextColor: colors.contrasts.grey4570,
    answerDistributionPadding: spacing.small,
    answerDistributionChartPadding: spacing.small,
    answerDistributionLegendPadding: spacing.small,
    answerDistributionSwatchColor: colors.contrasts.blue4570,
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium)
  };
};
export default generateComponentTheme;